import { numericUtil } from '@cmg/common';

import { ParticipationSetsGridColDef } from '../../types';

export type Value = number;

export const indicationColDef: ParticipationSetsGridColDef<Value> = {
  field: 'indicationTotal',
  headerName: 'Indication Total',
  type: ['numericColumn', 'number'],
  filter: 'agNumberColumnFilter',
  width: 157,
  floatingFilter: true,
  valueFormatter: ({ value }) => numericUtil.getDisplayValueForNumber(value, 0),
};
